/**
 * @flow
 * @relayHash f7490071705c1991d130a53b39b63b1e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MFADeactivationRequestList_viewer$ref = any;
export type MFADeactivationRequestListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  status?: ?string,
|};
export type MFADeactivationRequestListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: MFADeactivationRequestList_viewer$ref
  |}
|};
export type MFADeactivationRequestListQuery = {|
  variables: MFADeactivationRequestListQueryVariables,
  response: MFADeactivationRequestListQueryResponse,
|};
*/


/*
query MFADeactivationRequestListQuery(
  $first: Int
  $offset: Int
  $status: String
) {
  viewer {
    ...MFADeactivationRequestList_viewer_3m8j9l
    id
  }
}

fragment MFADeactivationRequestList_viewer_3m8j9l on Query {
  mfaDeactivationRequests(first: $first, offset: $offset, status: $status, orderBy: "-createdAt") {
    count
    edges {
      node {
        id
        status
        createdAt
        createdBy {
          id
          fullName
        }
        forUser {
          id
          email
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "status",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v3 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "status"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MFADeactivationRequestListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MFADeactivationRequestList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MFADeactivationRequestListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mfaDeactivationRequests",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-createdAt"
              },
              (v3/*: any*/)
            ],
            "concreteType": "MFADeactivationRequestNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "MFADeactivationRequestNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MFADeactivationRequestNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "createdBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "forUser",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MFADeactivationRequestListQuery",
    "id": null,
    "text": "query MFADeactivationRequestListQuery(\n  $first: Int\n  $offset: Int\n  $status: String\n) {\n  viewer {\n    ...MFADeactivationRequestList_viewer_3m8j9l\n    id\n  }\n}\n\nfragment MFADeactivationRequestList_viewer_3m8j9l on Query {\n  mfaDeactivationRequests(first: $first, offset: $offset, status: $status, orderBy: \"-createdAt\") {\n    count\n    edges {\n      node {\n        id\n        status\n        createdAt\n        createdBy {\n          id\n          fullName\n        }\n        forUser {\n          id\n          email\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8bb737fd8b79669960376fc81e03558d';
module.exports = node;
